// extracted by mini-css-extract-plugin
export default {"padMarginCenter":"PadMarginCenter_padMarginCenter__lD4fJ"};